module.exports = __webpack_public_path__ + "img/badgeReferencedLine.4cd8910b.svg";